<template>
  <div>
    <CapabilitiesList
      v-if="capabilities.length"
      :capabilities="capabilities"
      :class="$style.capabilities"
    />
    <p>
      {{ instructions.text }}
    </p>
    <ul>
      <li
        v-for="(step, index) in instructions.steps"
        :key="index"
        :class="$style.step"
      >
        {{ step }}
      </li>
    </ul>
    <CopyWell
      :content="copyWellTerminal.content"
      :label="copyWellTerminal.label"
      :location="`Create System - ${copyWellTerminal.label}`"
      :rows="copyWellTerminal.rows"
      :showTooltip="copyWellTerminal.showTooltip"
      :tooltipLabel="copyWellTerminal.tooltipLabel"
      @copyToClipboard="logTerminalSystemAdded"
    />
    <p>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" :class="$style.kbArticle" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M29.574 8.128a15.751 15.751 0 00-5.629-5.663A15.301 15.301 0 0016.109.319h-.218c-2.861 0-5.54.782-7.834 2.145a15.683 15.683 0 00-5.592 5.59A15.301 15.301 0 00.319 15.89v.218c0 2.861.782 5.54 2.145 7.834A15.685 15.685 0 008.06 29.54a15.293 15.293 0 007.825 2.139H16.108c2.861 0 5.54-.782 7.834-2.145a15.685 15.685 0 005.598-5.596 15.295 15.295 0 002.14-7.826v-.12-.103c0-2.861-.782-5.54-2.145-7.834zm-16.94 18.227c-1.152 0-1.958-.55-1.958-1.779 0-1.568 1.094-4.224 1.318-4.774l2.246-5.722c.23-.595-.058-.883-.32-.883-1.184 0-2.733 2.829-3.309 2.829a.454.454 0 01-.422-.428c0-.577 1.427-1.921 1.837-2.376a7.096 7.096 0 014.797-2.175c1.398-.001 2.883.851 1.718 3.999l-2.304 6.323a6.003 6.003 0 00-.54 1.792c-.005.044-.005.058-.005.071 0 .224.176.406.398.416.954 0 2.714-2.765 3.201-2.765.217.04.379.228.379.453l-.001.034c-.038.952-3.789 4.984-7.034 4.984zm5.318-17.19a2.061 2.061 0 01-2.183-2.208 2.656 2.656 0 012.635-2.592l.1-.002a2.118 2.118 0 012.115 2.228 2.61 2.61 0 01-2.611 2.575l-.061-.001z"/></svg>
      <a
        :href="kbLinkTerminal.href"
        rel="noopener noreferrer"
        target="_blank"
        @click="logTerminalSupportLinkClicked"
      >
        {{ kbLinkTerminal.text }}
      </a>
    </p>
    <div
      :class="$style.installerNotes"
    >
      <p :class="$style.subtleText">
        Note it may take up to two minutes to see the system in your Systems inventory.
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { onboardingTasks } from 'client/GrowthEngineering/utilities/GrowthConstants';
import CapabilitiesList from 'client/systems/CapabilitiesList.vue';
import CopyWell from 'client/components/FormValidation/CopyWell.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import EventManager from 'client/GrowthEngineering/EventManager';

const onboardingModule = 'OnboardingModule';

export default {
  name: 'TerminalInstructions',

  components: {
    CapabilitiesList,
    CopyWell,
  },

  props: {
    capabilities: {
      type: Array,
      default: () => [],
    },
    copyWellTerminal: {
      type: Object,
      default() {
        return null;
      },
      validator(value) {
        if (!value) {
          return true;
        }

        return !!(value.label
          && value.content
          && (value.rows ? typeof value.rows === 'number' : true));
      },
    },
    instructions: {
      required: true,
      type: Object,
    },
    kbLinkTerminal: {
      type: Object,
      default() {
        return null;
      },
      validator(value) {
        if (!value) {
          return true;
        }

        return !!(value.href && value.text);
      },
    },
    system: {
      default: '',
      type: String,
    },
    terminalName: {
      type: String,
      default: 'Terminal',
    },
  },

  methods: {
    ...mapActions(onboardingModule, [
      'completeOnboardingTask',
    ]),

    logTerminalSupportLinkClicked() {
      const { triggerSystemSupportLinkClicked } = EventHelper;
      triggerSystemSupportLinkClicked(
        {
          linkText: this.kbLinkTerminal.text,
          linkHref: this.kbLinkTerminal.href,
        },
      );
    },

    logTerminalSystemAdded() {
      const { triggerSystemAdded } = EventManager;
      triggerSystemAdded((`${this.system} ${this.terminalName}`).toLowerCase());
      this.completeOnboardingTask(onboardingTasks.discoverResources);
      this.completeOnboardingTask(onboardingTasks.systemCreated);
    },
  },
};
</script>
<style module>
@import './CreateSystem.css';

@value ( iconGrey ) from '~css/colors.css';

.kbArticle {
  display: inline-block;
  fill: iconGrey;
  height: 14px;
  margin-right: 4px;
  vertical-align: middle;
  width: 14px;
}

.installerNotes {
  border-top: 1px solid #eee;
  margin-top: 20px;
  padding-top: 20px;
}

.subtleText {
  color: iconGrey;
}

.capabilities {
  margin-bottom: var(--jc-spacer-large);
}

.step {
  margin-bottom: var(--jc-spacer-small);
}
</style>
